var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":"Air Conditioning","rules":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('Dropdown',{attrs:{"fieldId":'airCon' + _vm.idSuffix,"value":_vm.value,"error":errors[0],"options":_vm.airConOptions,"placeholder":"Select air conditioning","label":"Air Conditioning"},on:{"input":_vm.onInput}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }